import { render, staticRenderFns } from "./groupDetailsModal.vue?vue&type=template&id=928216a4&"
import script from "./groupDetailsModal.vue?vue&type=script&lang=js&"
export * from "./groupDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports